<template>
  <div class="itinerary-name-step">
    <div class="itinerary-name-step__row">
      <div class="itinerary-name-step__field itinerary-name-step__field--codigo">
        <label class="itinerary-name-step__label">Código</label>
        <a-input :value="codigo" disabled placeholder="Ex.: RT-001" />
      </div>

      <div class="itinerary-name-step__field itinerary-name-step__field--nome">
        <label class="itinerary-name-step__label">
          Nome roteiro <span class="itinerary-name-step__required">*</span>
        </label>
        <a-input
          :value="nome"
          :maxLength="120"
          placeholder="Ex.: Arujá / Dominalog"
          @change="onNomeChange"
        />
      </div>
    </div>

    <div class="itinerary-name-step__field">
      <label class="itinerary-name-step__label">Descrição (opcional)</label>
      <a-textarea
        :value="descricao"
        :maxLength="40"
        :rows="4"
        placeholder="Digite aqui uma descrição para esse roteiro"
        @change="onDescricaoChange"
      />
      <div class="itinerary-name-step__counter">{{ (descricao || '').length }} / 40</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItineraryNameStep',
  props: {
    codigo: { type: String, default: '' },
    nome: { type: String, default: '' },
    descricao: { type: String, default: '' },
  },
  methods: {
    readValue(e) {
      return e && e.target ? e.target.value : e;
    },
    onNomeChange(e) {
      this.$emit('update:nome', this.readValue(e));
    },
    onDescricaoChange(e) {
      const value = String(this.readValue(e) || '').slice(0, 40);
      this.$emit('update:descricao', value);
    },
  },
};
</script>

<style scoped lang="less">
@import '~@/shared/styles/variables.less';

.itinerary-name-step {
  &__row {
    display: flex;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  &__field {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    &--codigo {
      flex: 0 0 120px;
      width: 120px;
      margin-bottom: 0;
    }

    &--nome {
      flex: 1 1 auto;
      min-width: 0;
      margin-bottom: 0;
    }
  }

  &__label {
    display: block;
    margin-bottom: 6px;
  }

  &__required {
    color: #cf1322;
  }

  &__counter {
    text-align: right;
    font-size: 12px;
    color: @color-text-light;
    margin-top: 4px;
  }

  /deep/ .ant-input,
  /deep/ .ant-input-disabled {
    border-radius: 6px;
  }
}
</style>
